import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ApiGatewayUrl } from "../appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from "../core/rest";

export const streamErrorReportAPI = createAsyncThunk(
    "streamError/streamErrorReportAPI",
     async (request) => {
        try {
            const response = await Rest.post(ApiGatewayUrl + "/errorReport", request);
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
)

export const streamErrorSlice = createSlice({
    name: "streamError",
    initialState: {
    }

});
export const streamErrorAction = streamErrorSlice.actions;
export const streamErrorState = (state) => state.streamError;
export default streamErrorSlice.reducer;